import { PropsWithChildren } from 'react'

import { CaretDownOutlined } from '@ant-design/icons'
import { createStyles } from 'antd-style'

import { MenuButton } from '../MenuButton'

import { DropdownButtonProps } from './interface'

const useStyles = createStyles(() => ({
  compact: {
    padding: '0 2px  !important'
  },
  icon: {
    fontSize: '9px !important'
  }
}))

export const DropdownButton = ({
  className,
  compact,
  children,
  // 接收 Dropdown 组件传递进来的事件
  ...restProps
}: PropsWithChildren<DropdownButtonProps>) => {
  const { cx, styles } = useStyles()

  return (
    <MenuButton
      {...restProps}
      className={cx(
        {
          [styles.compact]: compact
        },
        className
      )}
    >
      {children}
      <CaretDownOutlined className={styles.icon} />
    </MenuButton>
  )
}
